/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_File_Deleted_SuccessInputs */

const en_transcript_file_deleted_success = /** @type {(inputs: Transcript_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcript file deleted successfully`)
};

const fr_transcript_file_deleted_success = /** @type {(inputs: Transcript_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier de transcription supprimé avec succès`)
};

const de_transcript_file_deleted_success = /** @type {(inputs: Transcript_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Protokolldatei wurde erfolgreich gelöscht.`)
};

const it_transcript_file_deleted_success = /** @type {(inputs: Transcript_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File di trascrizione eliminato con successo`)
};

const ru_transcript_file_deleted_success = /** @type {(inputs: Transcript_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл с расшифровкой успешно удален.`)
};

const es_transcript_file_deleted_success = /** @type {(inputs: Transcript_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo de transcripción eliminado correctamente`)
};

const zh_cn2_transcript_file_deleted_success = /** @type {(inputs: Transcript_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转录文件已成功删除`)
};

const ja_transcript_file_deleted_success = /** @type {(inputs: Transcript_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプトファイルが正常に削除されました`)
};

const hi_transcript_file_deleted_success = /** @type {(inputs: Transcript_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रांसक्रिप्ट फ़ाइल सफलतापूर्वक हटा दी गई`)
};

const pt_pt2_transcript_file_deleted_success = /** @type {(inputs: Transcript_File_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de transcrição excluído com sucesso`)
};

/**
* | output |
* | --- |
* | "Transcript file deleted successfully" |
*
* @param {Transcript_File_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_file_deleted_success = /** @type {((inputs?: Transcript_File_Deleted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_File_Deleted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_file_deleted_success(inputs)
	if (locale === "de") return de_transcript_file_deleted_success(inputs)
	if (locale === "it") return it_transcript_file_deleted_success(inputs)
	if (locale === "ru") return ru_transcript_file_deleted_success(inputs)
	if (locale === "es") return es_transcript_file_deleted_success(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_file_deleted_success(inputs)
	if (locale === "ja") return ja_transcript_file_deleted_success(inputs)
	if (locale === "hi") return hi_transcript_file_deleted_success(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_file_deleted_success(inputs)
	return en_transcript_file_deleted_success(inputs)
});